import { formatMoneyKzt, formatDateForDisplay } from "@/shared/utils";
import type { Locale } from "@/shared/utils";

export function generateTaskCode(projectName: string, taskId: number): string {
  const words = projectName.trim().split(/\s+/);
  const prefix = words
    .map((w) => w.charAt(0).toUpperCase())
    .join("")
    .slice(0, 4);
  return `${prefix || "T"}-${taskId}`;
}

export function formatBudget(budget: string | null, locale?: Locale): string {
  if (!budget) return "—";
  return formatMoneyKzt(budget, locale);
}

export function formatProjectDateRange(
  startDate: string | null,
  endDate: string | null,
): string {
  if (!startDate && !endDate) return "-";
  const start = startDate ? formatDateForDisplay(startDate) : "—";
  const end = endDate ? formatDateForDisplay(endDate) : "—";
  return `${start} — ${end}`;
}

export function formatBudgetCompact(budget: string | null, locale: Locale = "ru"): string {
  if (!budget) return "—";
  const num = parseFloat(budget);
  if (Number.isNaN(num)) return "—";

  const isEn = locale === "en";
  let value: number;
  let suffix: string;

  if (num >= 1_000_000_000) {
    value = num / 1_000_000_000;
    suffix = isEn ? "B" : "млрд";
  } else if (num >= 1_000_000) {
    value = num / 1_000_000;
    suffix = isEn ? "M" : "млн";
  } else if (num >= 1_000) {
    value = num / 1_000;
    suffix = isEn ? "K" : "тыс";
  } else {
    return `${Math.round(num)} ₸`;
  }

  const formatted = value % 1 === 0 ? String(Math.round(value)) : value.toFixed(1).replace(/\.0$/, "");
  return `${formatted} ${suffix} ₸`;
}

export function truncateText(text: string, maxLength: number): string {
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength) + "...";
}
